/**
 * Main Application Component
 * Entry point for the SwaraPoint web application
 */

import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AppRouter } from "./router/AppRouter";
import { config } from "./config";

function FallbackComponent() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="mt-2 text-gray-600">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
          className="mt-4 rounded bg-primary px-4 py-2 text-white"
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}

function SentryTestButton() {
  const handleTestSentry = () => {
    const error = new Error(
      `Manual Sentry test from ${config.sentry.environment} at ${new Date().toISOString()}`,
    );

    console.log(config.sentry.environment);

    Sentry.captureException(error, {
      tags: {
        source: "manual-test-button",
        environment: config.sentry.environment,
      },
      level: "error",
    });

    console.log("Manual Sentry test event sent.");
  };

  if (config.env.isProduction) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleTestSentry}
      className="fixed bottom-4 right-4 z-50 rounded bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-lg hover:bg-red-700"
    >
      Test Sentry
    </button>
  );
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <SentryTestButton />
    </Sentry.ErrorBoundary>
  );
}

export default App;
